module.exports = __webpack_public_path__ + "static/img/logo.fe4081c1.png";